var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.socialLinks),function(button,index){return _c('v-btn',{key:index,staticClass:"mr-1",attrs:{"icon":"","x-large":"","href":button.href,"target":"_blank","color":_vm.color}},[_c('v-icon',[_vm._v(_vm._s(button.icon))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }